import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=54c56f30&scoped=true"
import script from "./nav-header.vue?vue&type=script&lang=js"
export * from "./nav-header.vue?vue&type=script&lang=js"
import style0 from "./nav-header.vue?vue&type=style&index=0&id=54c56f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c56f30",
  null
  
)

export default component.exports